
import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import u from '@/utility/utility';
import DeliveryInfo from './components/DeliveryInfo.vue';
import { Order } from '@/models/order';
import { Customer } from '@/models/customer';
import authService from '@/services/auth-services';
import orderService from '@/services/order-service';
import paymentRequestServices from '@/services/payment-request-services';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

@Component({
    components: {
        Loading,
        'delivery-info': DeliveryInfo,
        ConfirmModal
    }
})
export default class AddNewPaymentRequest extends Vue {
    private customerInfo: Customer = {};
    private isLoading = false;
    private otherOption = {
        customerNote: '',
        defaultAddress: true
    };
    
    private isConfirm = false;
    private modalContent = '';

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }

    get totalChoose() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.filter(x => x.isChecked === true).length : 0;
    }

    private async created() {
        this.getCustomersInfo();
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }
    private async backToPrevious() {
        this.$router.push({ name: 'payment-request-new' });
    }
    private async submitPaymentRequest() {
        const isValid = await (this.$refs['observer'] as any).validate();
        if (isValid) {
            this.isLoading = true;
            const dataRequest = {
                UID: this.userInfo.userId,
                Username: this.userInfo.userName,
                NumberOfPack: this.totalChoose,
                Phone: this.customerInfo.PhoneNumber,
                Address: this.customerInfo.Address,
                Note: this.otherOption.customerNote,
                Status: 1,
                Packages: this.paymentRequestOrders
            };

            const result = await paymentRequestServices.createPaymentRequest(dataRequest);
            this.isLoading = false;
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Tạo mới yêu cầu giao hàng thành công!',
                });
                (window['getApp'] as any).$emit('SET_SELECTED_ORDER', []);
                this.$router.push({ name: 'payment-request-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                    return false;
                });
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Có lỗi trong quá trình xử lý dữ liệu!',
                });
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onOtherModalWallet(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'profile' });
        }
    }
}
